/* Freeze video to last frame — ilman fallback-kuvaa ja ilman ennenaikaista lukitusta */
(function () {
  var EPS = 0.04; // pysäytysmarginaali (~1–2 framea)

  function nearlyEnded(v) {
    return isFinite(v.duration) && v.duration > 0 && v.currentTime >= (v.duration - EPS);
  }

  function lockToLastFrame(v) {
    if (!isFinite(v.duration) || v.duration === 0) return;
    var t = Math.max(0, v.duration - EPS);
    try { if (Math.abs(v.currentTime - t) > 0.001) v.currentTime = t; } catch (e) {}
    try { v.pause(); } catch (e) {}
    v.dataset.frozen = "1";
  }

  function arm(v) {
    if (!v || v.dataset.freezeInit) return;
    v.dataset.freezeInit = "1";

    // iOS/Safari-yhteensopivuus
    v.setAttribute("playsinline", "");
    v.setAttribute("webkit-playsinline", "");
    v.preload = v.preload || "auto";

    function onTimeUpdate() {
      if (nearlyEnded(v)) {
        v.removeEventListener("timeupdate", onTimeUpdate);
        lockToLastFrame(v);
      }
    }

    // Merkitse, että toisto on alkanut; vasta sen jälkeen voidaan harkita lukitusta
    v.addEventListener("play", function () {
      v.dataset.started = "1";
      v.removeEventListener("timeupdate", onTimeUpdate);
      v.addEventListener("timeupdate", onTimeUpdate);
    });

    // Kun video päättyy luonnollisesti → lukitse viimeiseen frameen
    v.addEventListener("ended", function () { lockToLastFrame(v); });

    // ÄLÄ lukitse loadedmetadata:ssa – se aiheutti ennenaikaisen freezen
    v.addEventListener("loadedmetadata", function () {
      // ei-toimintaa, vain armi pitää olla paikallaan
    });

    // Palatessa välilehdelle / resizessa: lukitse vain jos video on jo lopussa JA toisto on joskus alkanut
    function relockIfEnded() {
      if (v.dataset.started && nearlyEnded(v)) lockToLastFrame(v);
    }
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) relockIfEnded();
    });
    window.addEventListener("resize", relockIfEnded);

    // Teeman mahdolliset attribuuttipäivitykset: reagoi vain jos video on jo lopussa
    var mo = new MutationObserver(function () { relockIfEnded(); });
    mo.observe(v, { attributes: true, attributeFilter: ["src", "poster"] });
  }

  function init(root) {
    (root || document)
      .querySelectorAll("superpowered-video > video[data-freeze-last-frame], video[data-freeze-last-frame]")
      .forEach(arm);
  }

  document.addEventListener("DOMContentLoaded", function () { init(document); });
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
